<template>
  <div id="chosen-instance-pop-up">
    <generate-qr-code :isPopupActive="showGenerate" :closeCallback="closeCallback" />
    <connect-tokens-popup :isPopupActive="showTokens" :closeCallback="closeCallback"/>

    <vs-popup :title="title" :active.sync="isActive" @close="onClose">
      <vs-table
          search
          pagination
          :data="instances"
          v-model="selected"
          :multiple="isMultiple"
          :max-items="itemsPerPage"
          ref="chosen-instance-table"
          noDataText="Sem dados disponíveis"
      >
        <template slot="header">
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4">
            <div class="p-4 mb-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">
                {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                {{ instances.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : instances.length }} de {{ queriedItems }}
              </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @touchstart.prevent="itemsPerPage=4" @click="itemsPerPage=4">  <span>4</span>  </vs-dropdown-item>
              <vs-dropdown-item @touchstart.prevent="itemsPerPage=10" @click="itemsPerPage=10"> <span>10</span> </vs-dropdown-item>
              <vs-dropdown-item @touchstart.prevent="itemsPerPage=15" @click="itemsPerPage=15"> <span>15</span> </vs-dropdown-item>
              <vs-dropdown-item @touchstart.prevent="itemsPerPage=20" @click="itemsPerPage=20"> <span>20</span> </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </template>

        <template slot="thead">
          <vs-th sort-key="name" class="columns">Nome</vs-th>
          <vs-th sort-key="nickname" class="columns">Apelido</vs-th>
          <vs-th sort-key="activated" class="columns">Status</vs-th>
          <vs-th sort-key="phone_number" class="columns">Telefone</vs-th>
          <vs-th v-if="isAllowedConnect">Ações</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr ref="chosen-instance-table-tr" :data="tr" :key="index" :id="tr.id" v-for="(tr, index) in data" >
            <vs-td>
              <p class="product-email text-center font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-nickname text-center font-medium truncate">{{ tr.nickname ? tr.nickname : '---'}}</p>
            </vs-td>

            <vs-td>
              <div class="flex justify-content-center">
                <vs-chip :color="parseConnectionStatusOrColor(tr.activated, true)" class="product-order-status">
                  {{ parseConnectionStatusOrColor(tr.activated, false) | title }}
                </vs-chip>
              </div>
            </vs-td>

            <vs-td>
              <p class="product-email text-center font-medium truncate">
                {{ tr.phone_number.length >= 12 ? maskPhoneNumber(tr.phone_number) : 'Não informado' }}
              </p>
            </vs-td>

            <vs-td v-if="isAllowedConnect">
              <div class="flex ml-3">
                <vx-tooltip class="flex" text="Conectar" v-if="!tr.integration_id && !tr.activated">
                  <feather-icon
                    icon="GridIcon"
                    v-if="tr.is_official"
                    @click.stop="openPopup('tokens', tr)"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  />
                  <feather-icon
                    v-else
                    icon="GridIcon"
                    @click.stop="openPopup('generate', tr)"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  />
                </vx-tooltip>
                <vx-tooltip class="flex" text="Conectar (Em nova guia)" v-else-if="tr.integration_id && !tr.activated">
                  <feather-icon
                    icon="GridIcon"
                    @click.stop="redirectToInstance('build', tr.id)"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <footer v-if="!isAllowedConnect">
        <div class="w-full d-flex " style="justify-content: center">
          <vs-button class="mr-2" color="primary" :disabled="(!this.selected || this.selected.length === 0) && !isAllowedNotSelect" @click.prevent="changeOfChosen()">
            <span>Salvar</span>
          </vs-button>
        </div>
      </footer>
    </vs-popup>
  </div>
</template>

<script>
import moduleUser from "@/store/user/moduleUser";
import VsDropdown from "@/components/vs-dropdown/dropdown.vue";
import VsDropdownMenu from "@/components/vs-dropdown/dropdown-menu.vue";
import VsDropdownItem from "@/components/vs-dropdown/dropdown-item.vue";
import GenerateQrCode from "@/views/instances/GenerateQrCode.vue";
import ConnectTokensPopup from "@/views/instances/ConnectTokensPopup.vue";

import {formatRouteTenantPath, maskPhoneNumber, parseConnectionStatusOrColor} from "@/utils";

export default {
  name: 'chosen-instance-pop-up',
  components: {ConnectTokensPopup, GenerateQrCode, VsDropdownItem, VsDropdownMenu, VsDropdown},
  props:{
    isActive:{
      type: Boolean,
      required: true
    },
    isCloudOnly:{
      type: Boolean,
      required: false,
      default(){ return false; }
    },
    isReadOnly:{
      type: Boolean,
      required: false,
      default(){ return false; }
    },
    isMultiple:{
      type: Boolean,
      required: false,
      default(){ return true; }
    },
    isAllowedNotSelect:{
      type: Boolean,
      required: false,
      default(){ return false; }
    },
    isAllowedConnect:{
      type: Boolean,
      required: false,
      default(){ return false; }
    },
    onlyAllowed:{
      type: Boolean,
      required: false,
      default(){ return false; }
    },
    title:{
      type: String,
      required: false,
      default(){ return 'Filtro de Conexões'; }
    },
    activeInstances:{
      required: false, 
      default(){ return null; },
      validator: prop => typeof prop === 'object' || prop === null
    }
  },
  data() {
    return {
      selected: [],
      itemsPerPage: 4,
      showTokens:false,
      showGenerate: false
    }
  },
  computed:{
    activeUser(){
      return this.$store.state.AppActiveUser
    },
    instances(){
      if (this.onlyAllowed) { return this.chosenInstances }
      if (this.$store.state.instance.instances === undefined){ return [] }
      if (this.isCloudOnly){ return this.$store.state.instance.instances.filter(instance => instance.is_official === this.isCloudOnly ) || [] }
      return this.$store.state.instance.instances || []
    },
    chosenInstances(){
      if (this.activeInstances){ return this.activeInstances }
      return this.$store.state.instance.chosenInstances !== undefined ? this.$store.state.instance.chosenInstances : []
    },
    currentPage(){
      return this.$refs['chosen-instance-table'] ? this.$refs['chosen-instance-table'].currentx : 1
    },
    queriedItems(){
      return this.$refs['chosen-instance-table'] ? this.$refs['chosen-instance-table'].queriedResults.length : this.instances.length
    }
  },
  watch:{
    selected(value){
      if (this.isMultiple) {
        this.clickHandler(value);
      }
    },
    isActive(value){
      if (value && this.isMultiple){
        setTimeout(()=> {
          this.selected = this.chosenInstances;
          this.styleHandler(this.$refs['chosen-instance-table-tr'], this.selected)
        }, 70)
      } else { this.selected = [] }
    },
  },
  methods:{
    maskPhoneNumber,
    parseConnectionStatusOrColor,
    changeOfChosen(){
      let listIds = []
      let user = JSON.parse(JSON.stringify(this.activeUser))

      if (this.selected instanceof Array){
        listIds = this.selected.map((instance) => { return instance.id });
      } else {
        listIds = [this.selected.id]
      }

      if (this.isReadOnly){
        this.$emit('chosen-instances', listIds);
        return this.onClose()
      }

      user.allowedToUnify = true
      user.chosenInstances = listIds

      this.$store.dispatch('user/update', user).then(()=>{
        this.$store.dispatch("instance/chosenInstancesUnion", user.id)
        this.onClose()
      }).catch((error) => { console.error(error) })
    },
    onClose(){
      this.$emit('close');
    },
    closeCallback() {
      this.showTokens = false
      this.showGenerate = false
    },
    openPopup(view, instance){
      this.$store.dispatch("instance/chooseInstanceObject", instance)
      if (view === 'tokens')        this.showTokens = true
      else if (view === 'generate') this.showGenerate = true
    },
    redirectToInstance(page, id){
      window.open(this.$router.resolve(formatRouteTenantPath(`/instances/${page}/${id}`)).href, '_blank');
    },
    removeObjectFromArrayById(id, arr) {
      const index = arr.findIndex(value => value.id === id);
      arr.splice(index, 1);
    },
    executeClickInElementById(id, arr) {
      arr.forEach((item) => {
        if (item.$attrs.id === id) { item.$el.click(); }
      });
    },
    styleHandler(tableTr, selected) {
      tableTr.forEach((tr) => {
        selected.some((item) => {
          if (item.id === tr.$attrs.id) {
            this.changeAttributesToChecked(tr);
          }
        });
      });
    },
    hasDuplicate(arr) {
      const hasDuplicate = arr.reduce((acc, obj) => {
        if (acc.includes(obj.id)) { return true; }
        acc.push(obj.id);
        return acc;
      }, []);
      return typeof hasDuplicate === 'boolean';
    },
    findDuplicateId(arr) {
      const seenIds = {};
      for (const { id } of arr) {
        if (seenIds[id]) { return id; }
        else { seenIds[id] = true; }
      }
      return null;
    },
    changeAttributesToChecked(tr, value = true) {
      tr.checked = value;
      tr._isSelected = value;
      tr.$el.childNodes[0].childNodes[0].firstChild.checked = value;

      if (value){
        tr.$el.classList.add("is-selected");
      } else {
        tr.$el.classList.remove("is-selected");
      }
    },
    clickHandler(value) {
      if (value.length > 0) {
        const hasDuplicateData = this.hasDuplicate(value);
        if (hasDuplicateData) {
          const duplicatedId = this.findDuplicateId(value);
          this.executeClickInElementById(duplicatedId, this.$refs['chosen-instance-table-tr']);
          this.removeObjectFromArrayById(duplicatedId, this.selected);
        }
      } else {
        this.$refs['chosen-instance-table-tr'].forEach((item) => {
          this.changeAttributesToChecked(item, false)
        });
      }
    },
  },
  mounted() {
    this.$events.on('closeAllPopUps', ()=>{
      this.closeCallback()
      this.onClose()
    });

    if (!moduleUser.isRegistered) {
      this.$store.registerModule('user', moduleUser)
      moduleUser.isRegistered = true
    }
  },
  beforeDestroy() {
    this.$events.off('closeAllPopUps', ()=>{
      this.closeCallback()
      this.onClose()
    });
  }
}
</script>

<style lang="scss">
.columns > .vs-table-text {
  justify-content: center !important;
}
</style>